<template>
  <div id="app">
    <b-card header="<i class='fa fa-magnifier'></i> Browse">
      <div class="row d-flex align-items-center mb-3 justify-content-md-between spaced">
        <div class="col-sm-12 col-xs-12 col-lg-4 mt-2">
          <div class="">
            <input type="text" placeholder="Pencarian" class="form-control" v-model="searchFilter">
          </div>     
        </div>
        <div class="col-sm-12 col-xs-12 col-lg-4 mt-2">
          <div class="">
            <model-list-select class="form-control" :list="jnijin"
              v-model="jnperijinan"
              option-value="id_ijin"
              option-text="nama_ijin"
              name="Jenis Perizinan"
              v-validate="'required'"
              placeholder="-- Pilih Jenis Perijinan --">
            </model-list-select>             
          </div>
        </div>
      </div>
      <div v-if="isLoading" style="height: 20rem" class="d-flex align-items-center justify-content-center">
          <half-circle-spinner
            :animation-duration="1000"
            :size="60"
            :color="'#000000'"
          />
        </div>  
      <transition name="fade" mode="out-in">    
        <div class="row" v-if="!isLoading" >
          <div class="col-12" style="overflow-y:scroll;">
            <table class="table table-bordered">
              <thead>
                <tr style="cursor: pointer;vertical-align: baseline">
                  <th @click="sort('NM_PERUSAHAAN')">Nama Perusahaan <i class="fa fa-arrows-v"></i></th>
                  <th @click="sort('no_mohon')">No Mohon <i class="fa fa-arrows-v pull-right"></i></th>
                  <!-- <th @click="sort('tgl_mohon')">Tgl Mohon <i class="fa fa-arrows-v pull-right"></i></th> -->
                  <th @click="sort('no_setuju')">No Setuju <i class="fa fa-arrows-v pull-right"></i></th>
                  <!-- <th @click="sort('tgl_setuju')">Tgl Setuju <i class="fa fa-arrows-v pull-right"></i></th> -->
                  <th @click="sort('nama_ijin')">Jenis Izin<i class="fa fa-arrows-v pull-right"></i></th>
                  <th @click="sort('status')">Status<i class="fa fa-arrows-v pull-right"></i></th>
                  <th></th>
                  <th></th>
                </tr> 
              </thead>
              <tbody>
                <tr v-for="brow in pageOfItems" :key="brow.id_permohonan">
                  <td>{{brow.NM_PERUSAHAAN}}</td>
                  <td>{{brow.no_mohon}} <br> <small>{{brow.tgl_mohon}}</small></td>
                  <!-- <td>{{brow.tgl_mohon}}</td> -->
                  <td>{{brow.no_setuju}} <br> <small>{{brow.tgl_setuju}}</small></td>
                  <!-- <td>{{brow.tgl_setuju}}</td> -->
                  <td>{{brow.nama_ijin}}</td>
                  <td :style="'background-color:'+tes(brow.status)">{{brow.ur_status}}</td>
                  <td width="10%">
                      <router-link class="btn btn-primary" :to="'/brows/detilbrows/' + brow.id_permohonan" title="Detil Pengajuan"><i class="fa fa-search"></i></router-link>
                      <button title="Catatan Petugas" @click="opencatatan(brow.id_permohonan)" type="button" class="btn btn-success"><i class="fa fa-list-ul" ></i> </button>
                      <!-- <a title="Print Izin" v-if="brow.no_setuju !== null" :href="'http://localhost/backper/public/api/pdf/' + user + '/' + brow.id_permohonan" target="_blank" class="btn btn-success" ><i class="fa fa-print"></i></a> -->
                      <a title="Print Izin" v-if="(brow.status != 99 && !((brow.id_ijin == 31 || brow.id_ijin == 32 || brow.id_ijin == 33 || brow.id_ijin == 34 || brow.id_ijin == 35 || brow.id_ijin == 36 || brow.id_ijin == 37 || brow.id_ijin == 38 || brow.id_ijin == 44 || brow.id_ijin == 13) && brow.fl_setuju == 'Y') && !((brow.id_ijin == 27 || brow.id_ijin == 30 || brow.id_ijin == 46 || brow.id_ijin == 47) && brow.fl_setuju == 'T' || (brow.id_ijin == 45 && brow.status == '91' && brow.fl_setuju == 'R')) && brow.no_setuju !== null && brow.nm_file === null || (brow.id_ijin == 49 && brow.status == '98') || (brow.id_ijin == 50 && brow.status == '98'))" :href="$http.options.base + '/api/pdf/' + user + '/' + brow.id_permohonan" target="_blank"  ><button type="button" name="button" class="btn btn-warning"> <i class="fa fa-print"></i></button> </a>
                      <a title="Print Izin" v-if="brow.no_setuju !== null && brow.nm_file !== null" :href="$http.options.base + brow.url_file + '/' + brow.nm_file" target="_blank" class="btn btn-warning"><i class="fa fa-print"></i></a>
                      <button v-if="brow.status == '90'" @click="opennew(brow.id_permohonan)" class="btn btn-secondary" title="Ajukan Kembali"><i class="fa fa-edit"></i></button>
                      <!-- <a title="Print Izin" v-if="brow.no_setuju !== null && brow.nm_file === null" :href="'http://perijinanbcbatam.beacukai.go.id/backper/public/api/pdf/' + user + '/' + brow.id_permohonan" target="_blank" class="btn btn-warning" ><i class="fa fa-print"></i></a>
                      <a title="Print Izin" v-if="brow.no_setuju !== null && brow.nm_file !== null" :href="'http://perijinanbcbatam.beacukai.go.id/repository/perijinanbatam/' + brow.url_file + '/' + brow.nm_file" target="_blank" class="btn btn-warning"><i class="fa fa-print"></i></a> -->
                      <!-- <a title="Print Izin" v-if="brow.no_setuju !== null" :href="'http://localhost/backper/public' + brow.url_file + '/' + brow.nm_file" target="_blank" class="btn btn-warning"><i class="fa fa-download"></i></a> -->
                    </td>
                  <td>{{ (brow.id_ijin == 27 || brow.id_ijin == 30) && brow.fl_setuju == 'Y' ? 'Diperiksa' : ((brow.id_ijin == 27 || brow.id_ijin == 30) && brow.fl_setuju == 'T' ? 'Tidak diperiksa' : brow.fl_setuju) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="ml-3 pb-0 pt-3">
              <jw-pagination :items="filteredData" @changePage="onChangePage"></jw-pagination>
          </div>        
        </div>
      </transition>
    </b-card>

    <b-modal fade hide-footer title="Catatan Petugas" size="lg" v-model="ModalCatatan" @ok="ModalCatatan = false">
      <div class="row">
        <div class="col-12">
          <table class="table table-bordered table-sm">
            <thead>
              <tr class="align-middle">
                <th>Nama Pegawai</th>
                <th>Level Pemeriksa</th>
                <th>Catatan</th>
                <th>Wkt Selesai</th>
                <!-- <th>Wkt Konfirmasi</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="catat in catatan" :key="catat.NAMA">
                <td>{{ catat.NAMA }}</td>
                <td>{{ catat.ur_pemeriksa }}</td>
                <td>{{ catat.catatan }}</td>
                <td>{{ catat.wk_selesai }}</td>
                <!-- <td>{{ catat.wk_konfirmasi }}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {HalfCircleSpinner} from 'epic-spinners'
import swal from 'sweetalert'
import { ModelListSelect } from 'vue-search-select'
export default {
  components: {
    HalfCircleSpinner, ModelListSelect
  },
  data () {
    return {
      searchFilter: '',
      isLoading: true,
      pageOfItems: [],
      ModalCatatan: false,
      jnijin: [],
      jnperijinan: '',
      catatan: [],
      listBrowse: [],
      currentSort: 'wk_kirim',
      currentSortDir: 'asc',
      user: this.$store.getters['auth/user']['username']
      // url: this.$http.options.root
    }
  },
  computed: {
    // dataNhiFiltered () {
    //   return this.datanhi.filter((nhi) => {
    //     return this.searchFilter.toLowerCase().split(' ').every(v => nhi.no_container.toLowerCase().includes(v))
    //   })
    // },
    filteredData: function () {
      return this.listBrowse.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      }).filter((items) => {
        for (var item in items) {
          if (String(items[item]).toLowerCase().indexOf(this.searchFilter.toLowerCase()) !== -1) {
            return true
          }
        }
        return false
      }).filter((items) => {
        if (this.jnperijinan === '') return true
        if (items.id_ijin === this.jnperijinan) return true
        return false
      })
    }
  },
  mounted () {
    this.browse()
    this.getJnIjin()
  },
  methods: {
    getJnIjin () {
      this.$http.get('ref/jnijin')
        .then(response => {
          this.jnijin = response.data
        })
    },
    opencatatan (idPermohonan) {
      this.getCatatan(idPermohonan)
    },
    getCatatan (idPermohonan) {
      var idmohon = {
        idijin: idPermohonan
      }
      this.$http.post('bc/petugas/approvecatatanpengguna', idmohon)
        .then(response => {
          this.catatan = response.data
          this.ModalCatatan = true
        })
    },
    sort: function (s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    browse () {
      var data = {
        user: this.$store.getters['auth/user']['username']
      }
      this.$http.post('brows/listv2', data).then((response) => {
        this.listBrowse = response.data
        this.isLoading = false
      })
    },
    onChangePage (pageOfItems) {
    // update page of items
      this.pageOfItems = pageOfItems
    },
    tes (status) {
      var warna
      if (status === '50') {
        warna = 'limegreen'
      } else if (status === '20' || status === '27' || status === '28' || status === '29') {
        warna = 'Yellow'
      } else if (status === '90') {
        warna = 'tomato'
      } else {
        warna = 'White'
      }
      return warna
    },
    opennew (id) {
      swal({
        title: 'Ajukan kembali data permohonan',
        text: 'Anda yakin akan kembali mengajukan data permohonan ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.isLoading = true
              this.ajukembali(id)
          }
        })
    },
    ajukembali (id) {
      var data = {
        id_permohonan: id
      }
      this.$http.post('ajukembali', data).then((response) => {
        swal(response.data.status, response.data.message, response.data.status)
        this.$router.push('/pengajuan/detilheader/' + response.data.id)
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Brows/ListBrowsV2.vue?3aceedd0